function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Flex, Stack } from "../layout";
import styled from "@emotion/styled";
import { DeezerLogo } from "../brand";
export const TopBar = (_param)=>{
    var { responsive = true } = _param, props = _object_without_properties(_param, [
        "responsive"
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BaseTopBar, _object_spread({
                display: responsive ? {
                    base: 'none',
                    sm: 'inherit'
                } : undefined
            }, props)),
            responsive && /*#__PURE__*/ _jsx(TopBarStacked, _object_spread({
                display: {
                    base: 'inherit',
                    sm: 'none'
                }
            }, props))
        ]
    });
};
const BaseTopBar = (_param)=>{
    var { children } = _param, flexProps = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Flex, _object_spread_props(_object_spread({
        width: "100%",
        alignItems: "center",
        py: "4"
    }, flexProps), {
        children: /*#__PURE__*/ _jsx(Flex, {
            alignItems: "center",
            width: "100%",
            children: children
        })
    }));
};
const ScrollableBaseTopBar = styled(BaseTopBar)`
	overflow: auto;
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */

	&::-webkit-scrollbar {
		display: none;
	}
`;
const TopBarStacked = (props)=>{
    const { children } = props;
    const [line1, line2] = decomposeTopBarChildren(children);
    if (line2.length === 0) {
        return /*#__PURE__*/ _jsx(BaseTopBar, _object_spread({}, props));
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BaseTopBar, _object_spread_props(_object_spread({
                pt: "4",
                pb: "4"
            }, props), {
                children: line1
            })),
            /*#__PURE__*/ _jsx(ScrollableBaseTopBar, _object_spread_props(_object_spread({
                pt: "0",
                pb: "4"
            }, props), {
                children: line2
            }))
        ]
    });
};
export const TopBarLogo = (props)=>{
    return /*#__PURE__*/ _jsx(Flex, _object_spread({
        me: {
            base: 2,
            sm: 16
        }
    }, props));
};
export const TopBarDeezerLogo = (props)=>{
    return /*#__PURE__*/ _jsx(DeezerLogo, _object_spread({
        height: {
            base: '20px',
            sm: '30px'
        },
        transform: {
            base: 'translateY(-5%)',
            sm: 'translateY(-10%)'
        }
    }, props));
};
export const TopBarList = (props)=>{
    return /*#__PURE__*/ _jsx(Stack, _object_spread({
        direction: "row",
        spacing: 4,
        flexGrow: 1
    }, props));
};
export const TopBarActions = (props)=>{
    return /*#__PURE__*/ _jsx(Stack, _object_spread({
        direction: "row",
        spacing: 4,
        ms: {
            base: 2,
            sm: 16
        }
    }, props));
};
function decomposeTopBarChildren(children) {
    const line1 = [];
    const line2 = [];
    const validChildren = React.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ React.isValidElement(child);
    });
    validChildren.forEach((child, index)=>{
        const key = index;
        if (child.type === TopBarList) {
            if (child.props.children) {
                line2.push(/*#__PURE__*/ _jsx(React.Fragment, {
                    children: child
                }, key));
            }
        } else {
            line1.push(/*#__PURE__*/ _jsx(React.Fragment, {
                children: child
            }, key));
            if (index !== validChildren.length - 1) {
                line1.push(/*#__PURE__*/ _jsx(TopBarList, {}, `${index}-spacer`));
            }
        }
    });
    return [
        line1,
        line2
    ];
}

//# sourceMappingURL=TopBar.js.map